import React from 'react'
import propTypes from 'prop-types'
import Tooltip from '../../Tooltip/Tooltip'
import FaIcon from '../../FaIcon/FaIcon'
import { useBp } from '../../../../utils/Breakpoints/Breakpoints'

import './NavItem.scss'

const NavItem = (props) => {
  const {
    id,
    href,
    tooltip = false,
    action,
    iconBp,
    icon,
    text,
    type,
    className,
  } = props

  const checkType = (t) => {
    let value
    switch (t) {
      case 'icon':
        t === type && (value = true)
        break
      case 'hybrid':
        t === type && (value = true)

        break
      case 'text':
        t === type && (value = true)

        break
    }

    return value
  }

  const aboveXs = useBp('> xs')

  const classNames = `btn ${
    checkType('hybrid')
      ? iconBp
        ? 'icon-btn'
        : 'nav-btn'
      : checkType('icon')
      ? 'icon-btn'
      : ''
  } ${id}-btn`

  const attributes = {
    id: id,
    className: `${classNames} ${className ? className : ''}`,
    type: 'button',
    onClick: action,
    ...(iconBp && { 'aria-label': text }),
    ...(tooltip &&
      (checkType('icon') || iconBp) && { 'data-tooltip-content': text }),
    ...(href
      ? { href: href, target: '_blank', rel: 'noopener noreferrer' }
      : { type: 'button' }),
  }

  const children = () => {
    return (
      <>
        {icon && <FaIcon {...icon} />}
        {!iconBp && checkType('hybrid') && text}
      </>
    )
  }

  return (
    <>
      {href ? (
        <a {...attributes}>{children()}</a>
      ) : (
        <button {...attributes}>{children()}</button>
      )}
      {tooltip && aboveXs && <Tooltip id={id} />}
    </>
  )
}

NavItem.propTypes = {
  action: propTypes.func,
  className: propTypes.string,
  iconBp: propTypes.bool,
  id: propTypes.string.isRequired,
  href: propTypes.string,
  tooltip: propTypes.bool,
  text: propTypes.string,
  type: propTypes.string.isRequired,
  icon: propTypes.shape(),
}

export default NavItem
